import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { TableColumnType } from "src/app/constants/table";
import { TextType } from "src/app/constants/text-type";
import { AccountFilterPayload, AccountModel, AccountDetail, AccountsList, AccountDetailModel } from "src/app/models/account";
import { ListItem } from "src/app/models/listItem";
import { TableColumn } from "src/app/models/table";
import { AccountService } from "src/app/services/account.service";
import { LookupService } from "src/app/services/lookup.service";

@Component({
    selector: 'mwp-member-accounting-account-transactions',
    templateUrl: './account-transactions.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccountTransactionsComponent implements OnInit {

    public apiUrl = ContentHeaderKey.AccountTransactions;
    public searchForm: FormGroup;
    public accounts: AccountModel[];
    public accountDetail: AccountDetail;
    public dateRangeTypes: ListItem[];
    public selectedAccountName: string;
    public selectedDateRangeName: string;

    public accountDetailsMatTableData: MatTableDataSource<AccountDetailModel> = new MatTableDataSource<AccountDetailModel>();
    public accountDetailColumns: TableColumn[] = [
        {
            columnName: 'Date',
            propertyId: 'dateToUse',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Transaction',
            propertyId: 'transaction',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Amount',
            propertyId: 'amount',
            textType: TextType.currency,
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Billing Period',
            propertyId: 'billingPeriodDisplay',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Benefit',
            propertyId: 'benefitName',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Payroll Code',
            propertyId: 'payrollCode',
            columnType: TableColumnType.label,
        },
    ];

    constructor(
        private accountService: AccountService,
        private formBuilder: FormBuilder,
        private lookupService: LookupService,
    ){
    }

    ngOnInit(): void {
        this.lookupService.getDateRangeTypes().subscribe((response: ListItem[]) => {
            this.dateRangeTypes = response;
            this.accountService.getMemberAccountsList().subscribe((response: AccountsList) => {
                this.accounts = response.accounts;
                this.searchForm = this.formBuilder.group({
                    accountID: [response.accounts[1].accountID, Validators.required],
                    dateRange: [this.dateRangeTypes[0].value, Validators.required],
                });
                this.loadAccounts();
            });
        });
    }

    public loadAccounts(): void {
        const payload: AccountFilterPayload = new AccountFilterPayload();
        payload.accountID = this.searchForm.get('accountID').value;
        payload.dateRangeDropDownEnum = this.searchForm.get('dateRange').value;

        this.accountService.getMemberAccounttransactions(payload).subscribe((response: AccountDetail) => {
            this.accounts.forEach((account: AccountModel) => {
                if (payload.accountID == account.accountID)
                    this.selectedAccountName = account.accountDescription;
            });
            this.dateRangeTypes.forEach((dateRange: ListItem) => {
                if (payload.dateRangeDropDownEnum.toString() == dateRange.value)
                    this.selectedDateRangeName = dateRange.text;
            });
            this.accountDetailsMatTableData.data = response.memberAccountDetails;
            this.accountDetail = response;
        });
    }
}